export const minimize_str = (str = "", remove_new_line = false) => {
  var matcher = /^[\r\n]?(\s+)/;
  if (matcher.test(str)) {
    /*
          Replace the initial whitespace
          globally and over multiple lines
        */
    str = str.replace(new RegExp("^" + str.match(matcher)[1], "gm"), "");
  } else {
    // Regex doesn't match so return the original string
    str = str;
  }
  if (remove_new_line) {
    str = str?.replace(/(\r\n|\n|\r)/gm, " ");
  }

  return str
    ?.replaceAll(/^\s*[\r\n]/gm, "")
    ?.replaceAll(/ +/g, " ")
    ?.replaceAll(/^[ ]+/g, "")
    ?.trimEnd();
};
function truncate_text(text = "", maxLength = 8) {
  if (text?.length <= maxLength) {
    return text;
  }

  const keepLength = maxLength - 3;
  const startLength = Math.floor(keepLength / 2);
  const endLength = keepLength - startLength;

  return text?.slice(0, startLength) + "..." + text?.slice(-endLength);
}

// `toLocaleString()` without a locale printed "1,200,000" on the server (Node) and "۱٬۲۰۰٬۰۰۰" in a Persian browser, so
// every client-rendered price failed hydration (chawk-bazar, ciseco had local copies for this). The locale is now fixed:
// "en-US" (the server's old output) unless "fa" is asked for explicitly. Formatters are built on first use: building
// Intl.NumberFormat (fa-IR above all) cost 130-190ms on a throttled phone when it ran at module load.
const number_formatters = {};
const number_formatter = (locale) => {
  const key = locale === "fa" ? "fa-IR" : "en-US";
  return (number_formatters[key] ??= new Intl.NumberFormat(key));
};

/** A price with thousands separators (decimals dropped, like before); "NaN" for a non-number, like before. */
export function price_format(num, locale) {
  const number = parseInt(num);
  return Number.isNaN(number) ? "NaN" : number_formatter(locale).format(number);
}

/** A small number (rate, percent, count) in the locale's digits; Latin digits unless `locale` is "fa". */
export const number_format = (value, locale) => {
  const number = Number(value);
  return Number.isFinite(number) ? number_formatter(locale).format(number) : String(value ?? "");
};

export const zero_pad_number = (number, pad = 2, pad_placeholder = "0") =>
  String(number).padStart(pad, pad_placeholder);

export const is_mongodb_id = (str) =>
  str?.length === 24 && /^[A-F0-9]+$/i.test(str);


export const detect_iranian_bank = (card_number, banks) => {
  const onlyNum = (str) => str.replace(/[^.\d]/g, "");
  card_number = onlyNum(String(card_number));
  if (card_number.length < 6) return undefined;
  const card_number_prefix = parseInt(card_number.substr(0, 6));

  const bank = banks?.filter((b) => b.card_no === card_number_prefix);
  return bank.length === 0 ? undefined : bank[0];
};

export const random_string = (len = 8, charset) => {
  charset =
    charset || "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let random_string = "";
  for (let i = 0; i < len; i++) {
    let random_poz = Math.floor(Math.random() * charset.length);
    random_string += charset.substring(random_poz, random_poz + 1);
  }
  return random_string;
};

export const convert_to_en_number = (str) => {
  return parseFloat(
    str
      ?.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (d) {
        return d?.charCodeAt(0) - 1632;
      }) // Convert Arabic numbers
      ?.replace(/[۰۱۲۳۴۵۶۷۸۹]/g, function (d) {
        return d?.charCodeAt(0) - 1776;
      }) // Convert Persian numbers
  );
};
export const convert_to_en_number_string = (str = "") => {
  return str
      ?.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (d) {
        return d?.charCodeAt(0) - 1632;
      }) // Convert Arabic numbers
      ?.replace(/[۰۱۲۳۴۵۶۷۸۹]/g, function (d) {
        return d?.charCodeAt(0) - 1776;
      }) // Convert Persian numbers
      ;
};

// chawk-bazar / ciseco (`digits_only` in helpers/accountInformation.js, also behind `parse_digits` and the wallet amount)
// and jument (`to_raw_amount` in the wallet modal, `toEn` in the price filter): typed text -> Latin digits only.
/** Persian / Arabic digits to Latin, every other character removed, at most `max_length` digits ("۰۹۱۲-۳" -> "09123"). */
export const digits_only = (value, max_length = Infinity) =>
  convert_to_en_number_string(String(value ?? ""))
    .replace(/[^0-9]/g, "")
    .slice(0, max_length);

export function fnv1a64(str) {
  let h = BigInt("0xcbf29ce484222325");
  const prime = BigInt("0x100000001b3");
  for (let i = 0; i < str.length; i++) {
    h ^= BigInt(str.charCodeAt(i));
    h *= prime;
  }
  return h.toString(16).slice(-16); // 16 hex chars
}

export function fnv1a(str) {
  let hash = 0x811c9dc5; // offset basis
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = (hash >>> 0) * 0x01000193;
  }
  return ("0000000" + (hash >>> 0).toString(16)).slice(-8); // 8 chars
}



export const handle_attribute_separator = (separator, value) => {

	const separators = {
		"virgool_and": 1,
		"comma_and": 2,
		"times": 3,
		"virgool": 4,
		"comma": 5,
		"newline": 6,
	}
  
	switch (separator) {
		case separators.comma: {
			return value?.join(", ");
		}
		case separators.comma_and: {
			const first_values = value?.slice(0, value?.length - 1);
			const last_value = value?.slice(value?.length - 1);
			if (first_values?.length >= 2) {
				return [first_values?.join(", "), last_value]?.join(" & ")
			} else {
				return value?.join(" & ")
			}
		}
		case separators.newline: {
			return value?.join("\n");
		}
		case separators.times: {
			return value?.join(" x ");
		}
		case separators.virgool: {
			return value?.join("، ");
		}
		case separators.virgool_and: {
			const first_values = value?.slice(0, value?.length - 1);
			const last_value = value?.slice(value?.length - 1);

			if (first_values?.length >= 2) {
				return [first_values?.join("، "), last_value]?.join(" و ")
			} else {
				return value?.join(" و ")
			}
		}

		default:
			return value?.join("، ");
	}

};